export const ORGANIZATION_ID = 'https://www.nerdwallet.com/#organization';

/**
 * NerdWallet's Organization node as nerdwallet.com emits it (NerdWallet/seo-pages
 * packages/json-ld/src/organization-schema.ts). No `@context`, so it can sit in the site `@graph`
 * or be wrapped as a standalone publisher. The single source for every ria-client JSON-LD block.
 */
export const ORGANIZATION_NODE = {
  '@id': ORGANIZATION_ID,
  '@type': 'Organization',
  name: 'NerdWallet',
  legalName: 'NerdWallet, Inc.',
  url: 'https://www.nerdwallet.com',
  logo: {
    '@type': 'ImageObject',
    url: 'https://www.nerdwallet.com/assets/img/nw-logos/NW-default_og-image.jpg',
  },
  foundingDate: '2009',
  sameAs: [
    'https://www.facebook.com/NerdWallet',
    'https://twitter.com/NerdWallet',
    'https://www.pinterest.com/nerdwallet',
    'https://nerdwallet.tumblr.com',
    'https://www.linkedin.com/company/nerdwallet',
    'https://www.glassdoor.com/Overview/Working-at-NerdWallet-EI_IE687336.11,21.htm',
    'https://www.instagram.com/nerdwallet',
    'https://www.youtube.com/channel/UCTTYccSBNghxcxULTGaO1bA',
  ],
  founder: [{ '@type': 'Person', name: 'Tim Chen' }],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '4150 N Drinkwater Blvd, Suite 200',
    addressLocality: 'Scottsdale',
    addressRegion: 'AZ',
    postalCode: '85251',
    addressCountry: { '@type': 'Country', name: 'US' },
  },
} as const;
